var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefrig2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    fill: "#b0b0b0",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#b0b0b0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.8 960c-49.6 0-90.4-40.8-90.4-90.4V120.8c0-49.6 40.8-90.4 90.4-90.4H776c49.6 0 90.4 40.8 90.4 90.4v749.6c0 24-9.6 46.4-26.4 64-16.8 16.8-40 26.4-64 26.4H292.8z m-42.4-89.6c0 23.2 19.2 42.4 42.4 42.4H776c23.2 0 42.4-19.2 42.4-42.4V506.4h-568v364z m568-412V120.8c0-23.2-19.2-42.4-42.4-42.4H292.8c-23.2 0-42.4 19.2-42.4 42.4v337.6h568z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.8 372.8c-13.6 0-24-10.4-24-24v-88c0-13.6 10.4-24 24-24s24 10.4 24 24v88c0 12.8-11.2 24-24 24zM360.8 726.4c-13.6 0-24-10.4-24-24v-88c0-13.6 10.4-24 24-24s24 10.4 24 24v88c0 12.8-11.2 24-24 24z",
    fill: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefrig2);
export default __webpack_public_path__ + "static/media/refrig (2).8389b8117fa01f08620217bd3d8f0a47.svg";
export { ForwardRef as ReactComponent };